let toastFunction;

export const ToastMsgInit = (toastFn) => {
  toastFunction = toastFn;
};

/**
 * Show an app toast.
 * @param {'success'|'error'|'warning'|'info'} type
 * @param {string|null} messageText - Simple toast body (legacy API).
 * @param {object} [options] - Rich toast options.
 * @param {'simple'|'notification'} [options.variant]
 * @param {string} [options.title]
 * @param {string} [options.description]
 * @param {string} [options.category]
 * @param {string} [options.href]
 * @param {string} [options.actionLabel]
 * @param {number} [options.duration]
 */
const ToastMsg = (type, messageText, options) => {
  if (!toastFunction) {
    console.warn("ToastMsg not initialized. Wrap your app with ToastProvider.");
    return;
  }
  toastFunction(type, messageText, options || {});
};

export default ToastMsg;
